export const ContactIcon = ({ width = '24', height = '24', ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M23.2592 8.92716C23.2592 4.8284 19.9308 1.5 15.842 1.5H8.16788C4.06912 1.5 0.740723 4.8284 0.740723 8.92716V10.9519C0.740723 14.142 2.77529 16.9765 5.78764 17.9938L6.08393 18.0926L5.92591 18.3593C5.52097 19.0506 4.97776 20.1469 4.25677 21.6975C4.16788 21.8852 4.20739 22.1025 4.35554 22.2506C4.50369 22.3988 4.73085 22.4383 4.90862 22.3494L13.6 18.3691H15.8321C19.921 18.3691 23.2494 15.0407 23.2494 10.942V8.91728L23.2592 8.92716Z"
            stroke="currentColor"
            strokeMiterlimit="10"
        />
        <path
            d="M8.13493 9.80664C7.62135 9.80664 7.19995 10.228 7.19995 10.7416C7.19995 11.2552 7.62135 11.6766 8.13493 11.6766C8.64851 11.6766 9.06991 11.2552 9.06991 10.7416C9.06991 10.228 8.64851 9.80664 8.13493 9.80664Z"
            fill="currentColor"
        />
        <path
            d="M15.8649 9.80664C15.3513 9.80664 14.9299 10.228 14.9299 10.7416C14.9299 11.2552 15.3513 11.6766 15.8649 11.6766C16.3785 11.6766 16.7999 11.2552 16.7999 10.7416C16.7999 10.228 16.3785 9.80664 15.8649 9.80664Z"
            fill="currentColor"
        />
        <path
            d="M11.9999 9.80664C11.4863 9.80664 11.0649 10.228 11.0649 10.7416C11.0649 11.2552 11.4863 11.6766 11.9999 11.6766C12.5135 11.6766 12.9349 11.2552 12.9349 10.7416C12.9349 10.228 12.5135 9.80664 11.9999 9.80664Z"
            fill="currentColor"
        />
    </svg>
);
